import React, { useContext, useEffect, useState } from "react";

import useOctokit from "./useOctokit";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  //how much projects per page to show
  const [showPerPage, setShowPerPage] = useState(() => {
    const laptopBreakpoint = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--laptop-small");
    if (window.innerWidth <= laptopBreakpoint) {
      return 4;
    }
    return 8;
  });

  const { repos, languages } = useOctokit();
  const [featured_projects, setFeatured_projects] = useState(repos);
  const [paginated_projects, setPaginated_projects] = useState(
    featured_projects.slice(0, showPerPage)
  );

  useEffect(() => {
    setFeatured_projects(repos);
    setPaginated_projects(repos.slice(0, showPerPage));
  }, [repos, showPerPage]);

  // paginate projects
  useEffect(() => {
    setPaginated_projects(featured_projects.slice(0, showPerPage));
  }, [featured_projects, showPerPage]);

  //  change  showPerPage on screen width shrinks

  // ensure the handleResize code is called a maximum of once per second.
  // https://www.pluralsight.com/guides/re-render-react-component-on-window-resize
  //   const debounce = (fn, ms) => {
  //     console.log("rersized");
  //     let timer;
  //     return (_) => {
  //       clearTimeout(timer);
  //       timer = setTimeout((_) => {
  //         timer = null;
  //         fn();
  //       }, ms);
  //     };
  //   };
  const handleResize = () => {
    const laptopBreakpoint = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--laptop-small");

    // console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
    // console.log(window.innerWidth <= laptopBreakpoint);
    // console.log(laptopBreakpoint);
    if (window.innerWidth <= laptopBreakpoint) {
      setShowPerPage(4);
      return;
    }
    setShowPerPage(8);
  };

  useEffect(() => {
    // const debouncedHandleResize = debounce(handleResize, 10);

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // paginate projects end

  // filter project

  const filterProjects = (topic) => {
    setFeatured_projects(() =>
      repos.filter((repo) => repo.topics.indexOf(topic) !== -1)
    );
  };
  // filter project end

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  //  page  heading  animation
  const toggleHoverAnimation = (e) => {
    e.target.classList.toggle("animate__rubberBand");
  };
  //  page  heading  animation end

  // magnatic btn effect
  const calculateDistance = (x1, y1, x2, y2) => {
    return Math.hypot(x1 - x2, y1 - y2);
  };

  const MagneticBtn = (e, btn) => {
    const { pageX: cursorX, pageY: cursorY } = e;
    const { x, y, bottom, right } = btn.current.getBoundingClientRect();
    const btnCenter = { cx: (x + right) / 2, cy: (y + bottom) / 2 };
    const triggerArea = 300;

    if (
      calculateDistance(btnCenter.cx, btnCenter.cy, cursorX, cursorY) <
      triggerArea
    ) {
      btn.current.style.transition = "all 0.3s";
      btn.current.style.transform = `translate(${
        (cursorX - btnCenter.cx) * 0.2
      }px,${(cursorY - btnCenter.cy) * 0.2}px)`;
      return;
    }
    btn.current.style.transform = `translate(0)`;
  };
  // magnatic btn effect  end

  return (
    <AppContext.Provider
      value={{
        repos,
        languages,
        isSidebarOpen,
        featured_projects,
        paginated_projects,
        showPerPage,
        setPaginated_projects,
        toggleSidebar,
        toggleHoverAnimation,
        MagneticBtn,
        filterProjects,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobaleContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
